import {MaterialDto} from '../../options/contract.types'

import {MixVariationOptions} from './types'

export const getAvailableMaterialVariations = (
  material: MaterialDto | null | undefined
): MixVariationOptions => {
  const materialVariations = material?.materialVariations
  if (!materialVariations?.setControls?.length && !materialVariations?.slumps?.length) {
    return {isEnabled: false, isSetControlAvailable: false, isSlumpAvailable: false}
  }

  return {
    isEnabled: true,
    isSlumpAvailable: !!materialVariations.slumps?.length,
    slumps: materialVariations.slumps ?? [],
    isSetControlAvailable: !!materialVariations.setControls?.length,
    setControls: materialVariations.setControls ?? []
  }
}
